import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { appTargetingMediaStatisticsData } from 'lib/api/datacenter';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';

const AppTargetingMediaStatistics = ({ extraCustomized }) => {
  let initParams = {
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    pltfomTpCode: 'all',
    sort: 'desc',
    order: 'ADVRTS_AMT',
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    MEDIA_CNT: { orderFlag: true },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          pltfomTpCodeFixed={['00', '03', '04']}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={appTargetingMediaStatisticsData}
        customized={{ ...extraCustomized, ...customized }}
        useFetch={false}
        borderRangeStart={9}
        borderRangeEnd={11}
      />
    </>
  );
};

export default AppTargetingMediaStatistics;
